// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3VFMs","content":"LayoutSettings_content__z3oFb"};